import React from "react";




class RatingNetworkAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "React",
            username: "",
            session: ""
        };
    }

    render() {
        return
        <div class = "square">
            
        </div>
    }

}

export default RatingNetworkAnalysis;